import React, { useEffect } from "react";
import { Box } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { customTab } from "../../../redux/slices/TabSlices";
import { SecondaryButton } from "../../../common/Buttons";
import { useTranslation } from "react-i18next";
import { getAutditTrail } from "../../../services/auditTrails";
import { getUpdatedData } from "../../../redux/slices/AuditTrailSlice";
import { assetStepsNames } from "../../../constants/constants";

const AssetsLinks = () => {
  const { t } = useTranslation();
  const { id } = useParams();
  let navigate = useNavigate();
  let dispatch = useDispatch();
  const updates = useSelector((state) => state.auditTrail.updates);
  const fetchAuditTrail = async () => {
    const result = await getAutditTrail(id);
    if (result?.success) {
      dispatch(getUpdatedData(result?.payLoad));
    } else {
      dispatch(getUpdatedData([]));
    }
  };
  useEffect(() => {
    fetchAuditTrail();
  }, []);
  const assetsList = [
    {
      name: t("assets-swiper-tab-1"),
      tabId: "1",
      highlight:
        updates.filter(
          (item) =>
            item?.objectName.toLowerCase() ===
              assetStepsNames[0].toLowerCase() ||
            item?.objectName.toLowerCase() ===
              "sub" + assetStepsNames[0].toLowerCase()
        ).length > 0,
    },
    {
      name: t("assets-swiper-tab-2"),
      tabId: "2",
      highlight:
        updates.filter(
          (item) =>
            item?.objectName === assetStepsNames[1] ||
            item?.objectName.toLowerCase() ===
              "sub" + assetStepsNames[1].toLowerCase()
        ).length > 0,
    },
    {
      name: t("assets-swiper-tab-3"),
      tabId: "3",
      highlight:
        updates.filter(
          (item) =>
            item?.objectName === assetStepsNames[2] ||
            item?.objectName.toLowerCase() ===
              "sub" + assetStepsNames[2].toLowerCase()
        ).length > 0,
    },
    {
      name: t("assets-swiper-tab-4"),
      tabId: "4",
      highlight:
        updates.filter(
          (item) =>
            item?.objectName === assetStepsNames[3] ||
            item?.objectName.toLowerCase() ===
              "sub" + assetStepsNames[3].toLowerCase()
        ).length > 0,
    },
    {
      name: t("assets-swiper-tab-5"),
      tabId: "5",
      highlight:
        updates.filter(
          (item) =>
            item?.objectName === assetStepsNames[4] ||
            item?.objectName.toLowerCase() ===
              "sub" + assetStepsNames[4].toLowerCase()
        ).length > 0,
    },
    {
      name: t("assets-swiper-tab-6"),
      tabId: "6",
      highlight:
        updates.filter(
          (item) =>
            item?.objectName === assetStepsNames[5] ||
            item?.objectName.toLowerCase() ===
              "sub" + assetStepsNames[5].toLowerCase()
        ).length > 0,
    },
    {
      name: t("assets-swiper-tab-7"),
      tabId: "7",
      highlight:
        updates.filter(
          (item) =>
            item?.objectName === assetStepsNames[6] ||
            item?.objectName.toLowerCase() ===
              "sub" + assetStepsNames[6].toLowerCase()
        ).length > 0,
    },
    {
      name: t("loans"),
      tabId: "8",
      highlight:
        updates.filter(
          (item) =>
            item?.objectName === assetStepsNames[7] ||
            item?.objectName.toLowerCase() ===
              "sub" + assetStepsNames[7].toLowerCase()
        ).length > 0,
    },
    {
      name: t("assets-swiper-tab-8"),
      tabId: "9",
      highlight:
        updates.filter(
          (item) =>
            item?.objectName === assetStepsNames[8] ||
            item?.objectName.toLowerCase() ===
              "sub" + assetStepsNames[8].toLowerCase()
        ).length > 0,
    },
  ];
  const handleClickLink = (userId) => {
    let tabId = userId - 0;
    dispatch(customTab(tabId));
    navigate(`/cases/${id}/assets/balance-of-assets`);
  };

  return (
    <Box className="assets-link-container">
      {assetsList.map((el) => (
        <Box
          className={`assets-link-bar ${el.highlight ? "highlight" : ""}`}
          key={el.height}
        >
          <h5 style={{ marginLeft: "3rem" }}>{el.name}</h5>

          <SecondaryButton
            title={t("go-check")}
            fontSize="13px"
            fontWeight="400"
            textTransform="initial"
            padding="2px 10px"
            borderRadius="20px"
            click={() => {
              handleClickLink(el.tabId);
            }}
          />
        </Box>
      ))}
    </Box>
  );
};

export default AssetsLinks;
